const SamplesGridColumnSubtext = ({ text }: { text: string }) => (
  <div className="samples-grid__column-subtext">{text}</div>
);

export default SamplesGridColumnSubtext;
